import { Injectable, OnDestroy } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { AppService } from '@Core/services/proprietary/app.service';
import { DataSourceStatus } from '@Core/services/proprietary/datasource';
import { ResetState, SetObjectState } from './productline-config-object.actions';
import { normalize, rootSchema } from './productline-config-object.normalize';
import { ProductLineConfigObjectState } from './productline-config-object.state';

export enum EventType {
    Update = 'Update',
    Create = 'Create',
    Delete = 'Delete'
}

@Injectable()
export class ProductLineConfigObjectService implements OnDestroy {
    private dsGetSub: Subscription;

    constructor(private store: Store, private app: AppService /*, private router : Router*/) { }

    ngOnDestroy() {
        if (this.dsGetSub) {
            this.dsGetSub.unsubscribe();
        }
    }

    public async loadObjects(lineCodes: any) {
        return new Promise(async (resolve) => {
            for (var i in lineCodes) {
                await this.loadObjectNow(lineCodes[i].Line_Code);
            }
            resolve(true);
        });
    }

    reset() {
        this.store.dispatch(new ResetState());
    }

    private removeSubscription() {
        if (this.dsGetSub) {
            this.dsGetSub.unsubscribe();
        }
    }

    private async loadObjectNow(lineCode: any) {
        return new Promise(async (resolve) => {
            this.removeSubscription();
            this.app.dsProductLineConfigGet.reset();

            //Note: loadObject will not unload other product lines already loaded into state.   
            // Manually call reset if you want other products unloaded.
            let found = this.store.selectSnapshot(ProductLineConfigObjectState.productLineExists)(lineCode);

            if (!found) {
                this.app.dsProductLineConfigGet.get({ json: 'CT2', Line_Code: lineCode, View: 'Full' });

                this.dsGetSub = this.app.dsProductLineConfigGet.status$.subscribe((status) => {
                    switch (status) {
                        case DataSourceStatus.Ready:
                            this.removeSubscription();

                            let data = this.app.dsProductLineConfigGet.data;
                            let normalizedData = normalize(data, rootSchema);
                            this.store.dispatch(new SetObjectState(normalizedData.entities)).subscribe(() => {
                                resolve(true);
                            });
                            break;
                        case DataSourceStatus.Error:
                            this.removeSubscription();
                            resolve(true);
                            break;
                    }
                });
            } else {
                resolve(true);
            }
        });
    }
}
